const SalonMarkerBlack = ({ className, width = '2.8rem', height = '3.6rem' }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 28 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 14.9143C28 23.1512 14 36 14 36C14 36 0 23.1512 0 14.9143C0 6.67735 6.26801 0 14 0C21.732 0 28 6.67735 28 14.9143Z"
      fill="#3C3C3B"
    />
    {/* <path d="M13.5898 18H14.8138V9.996H12.8698L12.1978 11.124H13.5898V18Z" fill="white" /> */}
  </svg>
);

export default SalonMarkerBlack;
